module.exports = __webpack_public_path__ + "img/symbol_7.66ef350e.png";